import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-031-chart",
  "use": "icon-031-chart-usage",
  "viewBox": "0 0 150 150",
  "content": "<symbol viewBox=\"0 0 150 150\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-031-chart\"><g><g fill=\"#e1e6e9\"><path d=\"m20.124 0-6.877 15.294h13.754z\" /><path d=\"m20.124 150-6.877-15.294h13.754z\" /><path d=\"m18.129 10.919h3.99v131.434h-3.99z\" /><path d=\"m20.124 74.65h116.63v3.99h-116.63z\" /></g><path d=\"m25.793 31.883h11.619v42.767h-11.619z\" fill=\"#27a2db\" /><path d=\"m39.337 43.94h11.619v30.728h-11.619z\" fill=\"#44c4a1\" /><path d=\"m52.899 31.883h11.619v42.767h-11.619z\" fill=\"#e56353\" /><path d=\"m66.461 21.401h11.619v53.249h-11.619z\" fill=\"#fcd462\" /><path d=\"m120.917 78.64h11.619v42.767h-11.619z\" fill=\"#27a2db\" /><path d=\"m107.355 78.64h11.619v30.728h-11.619z\" fill=\"#44c4a1\" /><path d=\"m93.811 78.64h11.619v42.767h-11.619z\" fill=\"#e56353\" /><path d=\"m80.25 78.64h11.619v53.249h-11.619z\" fill=\"#fcd462\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/031-chart.svg
// module id = /FUq
// module chunks = 102